import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "clock",
  "use": "clock-usage",
  "viewBox": "4 4 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"4 4 16 16\" id=\"clock\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12 17.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11m0 2.5a8 8 0 1 0 0-16 8 8 0 0 0 0 16\" clip-rule=\"evenodd\" /><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.904 8.261a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol